module.exports = __webpack_public_path__ + "img/video-front.4d473420.png";